<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_MODULE } from '@/state/modules/product'
import { PRODUCT_AI_MODULE } from '@/state/modules/productAi'
import { PRODUCT_LABEL_MODULE } from '@/state/modules/productLabel'
import { lookupMethods, productMethods, productAIMethods, productLabelMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ProductAiTable from "@/views/pages/product/components/productAiTable";
import ProductSourceTable from "@/views/pages/product/components/productSourceTable";
import ProductPrinterProofTable from "@/views/pages/product/components/productPrinterProofTable";
import ProductPaymentTable from "@/views/pages/product/components/productPaymentTable";
import ProductLabelTable from "@/views/pages/product/components/productLabelTable";
import ProductQueryTable from "@/views/pages/product/components/productQueryTable";
import ProductCertTable from "@/views/pages/product/components/productCertTable";
import ProductSDSTable from "@/views/pages/product/components/productSDSTable";
import ProductRecommendationTable from "@/views/pages/product/components/productRecommendationTable";
/**
 * Tabs & accordions component
 */
export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.halex")]),
    },
    components: {
        Layout, PageHeader, Multiselect, DatePicker, ProductAiTable,
        ProductSourceTable, ProductPrinterProofTable, ProductPaymentTable,
        ProductLabelTable, ProductQueryTable, ProductCertTable, ProductSDSTable, ProductRecommendationTable
    },
    beforeRouteLeave(to, from, next) {
        if (to.name == "Product-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-ai-update" || to.name == "Product-ai-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-label-update" || to.name == "Product-label-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-payment-update" || to.name == "Product-payment-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-printer-proof-update" || to.name == "Product-printer-proof-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-query-update" || to.name == "Product-query-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-recommendation-update" || to.name == "Product-recommendation-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-cert-update" || to.name == "Product-cert-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-source-update" || to.name == "Product-source-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        } else if (to.name == "Product-sns-update" || to.name == "Product-sns-create") {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_AI_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PAYMENT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_QUERY_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_RECOMMENDATION_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_CERT_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
            sessionHelper.clearSearch(SESSION.PRODUCT_HALEX_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        ...mapState(PRODUCT_AI_MODULE),
        ...mapState(PRODUCT_LABEL_MODULE),
        data() {
            return this.$store.state.product.details;
        },
        formDdl() {
            return this.$store.state.lookup.formDdl;
        },
        classDdl() {
            return this.$store.state.lookup.classDdl;
        },
        // moaDdl() {
        //     return this.$store.state.lookup.moaDdl;
        // },
        typeDdl() {
            return this.$store.state.lookup.typeDdl;
        },
        purposeDdl() {
            return this.$store.state.lookup.purposeDdl;
        },
        brandDdl() {
            return this.$store.state.lookup.brandDdl;
        },
        statusDdl() {
            return this.$store.state.lookup.statusDdl;
        },
    },
    data() {
        const times = ddlHelper.getShellLifeTime();
        return {
            title: i18n.t("label.updateX", [i18n.t("module.halex")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.halex"),
                    href: "/product",
                },
                {
                    text: i18n.t("label.updateX", [i18n.t('module.halex')]),
                    active: true,
                },
            ],
            submitted: false,
            productID: '',
            productAiTableRef: null,
            isLoading: true,
            isLoadingAll: true,
            triggerProductID: null, // a simple counter to force change
            triggerTab: null, // a simple counter to force change
            filter: "",
            timeDdl: times,
            permissions: sessionHelper.getPermissions(),
            updatePermission: null,
            exportPermission: null,
            readPermission: null,
            labelFields: [
                { key: "product", sortable: true, label: i18n.t("module.halex"), },
                { key: "name", sortable: true, label: i18n.t("label.name") },
                { key: "packageSize", sortable: true, label: i18n.t("label.packageSize") },
                { key: "isActive", sortable: true, label: i18n.t("label.recordStatus") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
            labelSortBy: "name",
            labelPerPage: SHARED.DEFAULT_PAGE_SIZE,
            labelPageOptions: [10, 25, 50, 100],
            labelCurrentPage: 1,
        };
    },
    validations: {
        data: {
            formulationID: { required },
            classID: { required },
            // moaID: { required },
            typeID: { required },
            purposeID: { required },
            statusID: { required },
            brandName: { required },
            // lrmp: { required },
            referenceNumber: { required },
            // dor: { required },
            // expiredDate: { required },
            // dorSubmissionDate: { required },
            // approvalDate: { required },
            // endorseLabel: { required },
            // shelfLifeTime: {
            //     required: function () {
            //         if (this.data.shelfLifeProduction === true) {
            //             return false;
            //         }
            //         else {
            //             return true;
            //         }
            //     }
            // },
        },
    },
    async created() {
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_HALEX_SEARCH);
        await this.validPermissions();

        this.getProductData();
        this.lookupProductgetLookupProductCreateUpdates({ hasOptionAll: false });
    },
    methods: {
        ...productMethods,
        ...lookupMethods,
        ...productAIMethods,
        ...productLabelMethods,

        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_HPRODUCT_HPR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_HPRODUCT_HPU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_HPRODUCT_HPE")) {
                this.exportPermission = true;
            }
            else {
                this.exportPermission = false;
            }
        },

        onTabClick(value) {
            this.triggerProductID = this.searchCriteria.selectedRecordId;
            this.triggerTab = value;
        },

        async getProductData() {
            this.isLoading = true;
            this.isLoadingAll = true;
            if (this.readPermission == true) {
                await this.getProduct({ id: this.searchCriteria.selectedRecordId });
            }
            this.isLoading = false;
            this.isLoadingAll = false;
            this.productID = this.searchCriteria.selectedRecordId;
        },

        exportData() {
            var id = this.searchCriteria.selectedRecordId;
            if (this.exportPermission == true) {
                this.exportProduct({ id });
            }
        },

        requestUpdate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                this.isLoading = true;
                let data = {
                    id: this.data.uuid,
                    formulationID: this.data.formulationID.value,
                    classID: this.data.classID.value,
                    // moaID: this.data.moaID.value,
                    typeID: this.data.typeID.value,
                    purposeID: this.data.purposeID.value,
                    brandName: this.data.brandName,
                    lrmp: this.data.lrmp,
                    referenceNumber: this.data.referenceNumber,
                    dor: this.data.dor,
                    expiredDate: this.data.expiredDate,
                    dorSubmissionDate: this.data.dorSubmissionDate,
                    remark: this.data.remark,
                    approvalDate: this.data.approvalDate,
                    isRegisterCert: this.data.isRegisterCert,
                    shelfLifeProduction: this.data.shelfLifeProduction,
                    statusID: this.data.statusID.value,
                    endorseLabel: this.data.endorseLabel,
                    shelfLifeTime: this.data.shelfLifeTime.code,
                };

                if (this.updatePermission == true) {
                    this.updateProductHalex({ data });
                }
            }
        }
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                    v-if="isLoadingAll == true">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
                <div class="card" v-else>
                    <div class="card-body" v-if="readPermission == true">
                        <b-tabs pills justified content-class="p-3 text-muted">
                            <b-tab active class="border-0">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.halex') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <form @submit.prevent="requestUpdate">
                                    <!--  -->

                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group id="formulationID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.form')" label-for="formulationID">
                                                <multiselect v-model="data.formulationID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="formDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.formulationID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.form")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="classID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.class')" label-for="classID">
                                                <multiselect v-model="data.classID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="classDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.classID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.class")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <!-- <div class="col-md-6">
                                            <b-form-group id="moaID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.moa')" label-for="moaID">
                                                <multiselect v-model="data.moaID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="moaDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.moaID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.moa")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div> -->

                                        <div class="col-md-6">
                                            <b-form-group id="typeID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.type')" label-for="typeID">
                                                <multiselect v-model="data.typeID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="typeDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.typeID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.type")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="purposeID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.purpose')" label-for="purposeID">
                                                <multiselect v-model="data.purposeID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="purposeDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.purposeID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.purpose")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <!-- <div class="col-md-6">
                                            <b-form-group id="statusID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.status')" label-for="statusID">
                                                <multiselect v-model="data.statusID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="purposeDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.statusID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.status")])
                                                        }}</span>
                                                </div>
                                            </b-form-group>
                                        </div> -->


                                        <div class="col-md-6">
                                            <b-form-group id="brandName" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.name')" label-for="brandName">
                                                <b-form-input id="title" v-model.trim="data.brandName" :class="{
                                                    'is-invalid': submitted && !$v.data.brandName.required
                                                }"></b-form-input>
                                                <div v-if="submitted && !$v.data.brandName.required"
                                                    class="invalid-feedback">
                                                    <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="lrmp" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.lrmp')" label-for="lrmp">
                                                <b-form-input id="title" v-model.trim="data.lrmp"></b-form-input>
                                                <!-- <div v-if="submitted && (!$v.data.lrmp.required)"
                                                    class="invalid-feedback">
                                                    <span>{{ $t("message.requiredX", [$t("label.lrmp")]) }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="referenceNumber" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.XreferenceNumber', [$t('module.halex')])"
                                                label-for="referenceNumber">
                                                <b-form-input id="title" v-model.trim="data.referenceNumber" :class="{
                                                    'is-invalid': submitted && !$v.data.referenceNumber.required
                                                }"></b-form-input>
                                                <div v-if="submitted && !$v.data.referenceNumber.required"
                                                    class="invalid-feedback">
                                                    <span>{{ $t("message.requiredX", [$t("label.XreferenceNumber",
                                                        [$t('module.halex')])]) }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-6">
                                            <b-form-group id="dor" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.dor')" label-for="dor">
                                                <date-picker v-model="data.dor" type="date" format="YYYY-MM-DD"
                                                    value-type="format" placeholder="Select date"></date-picker>

                                                <!-- <div v-if="submitted && !$v.data.dor.required" class="invalid-feedback"
                                                    style="display: block !important;">
                                                    <span>{{ $t("message.requiredX", [$t("label.dor")]) }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-6">
                                            <b-form-group id="expiredDate" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.doe')" label-for="expiredDate">
                                                <date-picker v-model="data.expiredDate" type="date" format="YYYY-MM-DD"
                                                    value-type="format" placeholder="Select date"></date-picker>

                                                <!-- <div v-if="submitted && !$v.data.expiredDate.required"
                                                    class="invalid-feedback" style="display: block !important;">
                                                    <span>{{ $t("message.requiredX", [$t("label.doe")]) }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-6">
                                            <b-form-group id="dorSubmissionDate" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.dorSubmissionDate')" label-for="dorSubmissionDate">
                                                <date-picker v-model="data.dorSubmissionDate" type="date"
                                                    format="YYYY-MM-DD" value-type="format"
                                                    placeholder="Select date"></date-picker>

                                                <!-- <div v-if="submitted && !$v.data.dorSubmissionDate.required"
                                                    class="invalid-feedback" style="display: block !important;">
                                                    <span>{{ $t("message.requiredX", [$t("label.dorSubmissionDate")])
                                                        }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-6">
                                            <b-form-group id="approvalDate" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.approvalDate')" label-for="approvalDate">
                                                <date-picker v-model="data.approvalDate" type="date" format="YYYY-MM-DD"
                                                    value-type="format" placeholder="Select date"></date-picker>

                                                <!-- <div v-if="submitted && !$v.data.approvalDate.required"
                                                    class="invalid-feedback" style="display: block !important;">
                                                    <span>{{ $t("message.requiredX", [$t("label.approvalDate")])
                                                        }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="statusID" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.status')" label-for="statusID">
                                                <multiselect v-model="data.statusID"
                                                    deselect-label="Can't remove this value" track-by="value"
                                                    label="text" placeholder="Select one" :options="statusDdl"
                                                    :searchable="true" :allow-empty="false">
                                                </multiselect>
                                                <div v-if="submitted && !$v.data.statusID.required"
                                                    style="color: #ff3d60; font-size: 80%">
                                                    <span>{{ $t("message.atLeastOneSelectedX", [$t("module.status")])
                                                    }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="endorseLabel" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.endorseLabel')" label-for="lrmp">
                                                <b-form-input id="title"
                                                    v-model.trim="data.endorseLabel"></b-form-input>
                                                <!-- <div v-if="submitted && (!$v.data.endorseLabel.required)"
                                                    class="invalid-feedback">
                                                    <span>{{ $t("message.requiredX", [$t("label.endorseLabel")])
                                                    }}</span>
                                                </div> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-6">
                                            <b-form-group id="remark" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.remark')" label-for="remark">
                                                <textarea v-model="data.remark" class="form-control" name="textarea"
                                                    rows="5"></textarea>
                                                <!-- <b-form-input id="remark" v-model.trim="data.remark"></b-form-input> -->
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="shelfLifeTime" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.shelfLifeTimeYear')" label-for="shelfLifeTime">
                                                <multiselect v-model="data.shelfLifeTime" track-by="code" label="name"
                                                    placeholder="Select one" :options="timeDdl" :searchable="true"
                                                    :allow-empty="true">
                                                </multiselect>
                                            </b-form-group>
                                        </div>

                                        <div class="col-lg-12 d-flex align-items-center justify-content-end">
                                            <b-form-group style="padding-right: 10px;">
                                                <b-form-checkbox id="isRegisterCert" v-model="data.isRegisterCert"
                                                    :value="true" :unchecked-value="false" switch>
                                                    {{ $t('label.isRegisterCert') }}
                                                </b-form-checkbox>
                                            </b-form-group>
                                            <!-- <b-form-group>
                                                <b-form-checkbox id="shelfLifeProduction"
                                                    v-model="data.shelfLifeProduction" :value="true"
                                                    :unchecked-value="false" switch>
                                                    {{ $t('label.isShelfLifeProduction') }}
                                                </b-form-checkbox>
                                            </b-form-group> -->
                                        </div>

                                    </div>
                                    <div class="mt-4 text-center" style="float: right">
                                        <button class="btn btn-primary w-md waves-effect waves-light"
                                            style="margin-right: 10px" type="submit"
                                            :disabled="status.update || updatePermission != true">
                                            {{ $t("label.updateX", [$t("module.halex")]) }}
                                        </button>

                                        <a class="btn btn-info w-md waves-effect waves-light" @click="exportData"
                                            v-if="exportPermission == true" style="margin-right: 10px">
                                            {{ $t("label.export") }}
                                        </a>
                                    </div>
                                </form>
                            </b-tab>

                            <b-tab @click="onTabClick('productAI')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productAI') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <productAiTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productSource')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productSource') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductSourceTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productQuery')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.query') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductQueryTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productPrinterProof')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.printerProof') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductPrinterProofTable :trigger-tab="triggerTab"
                                    :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productPayment')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productPayment') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductPaymentTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productLabel')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productLabel') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductLabelTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productCert')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{
                                        $t('module.productRegisterationCertification') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductCertTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productSDS')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.productSNS') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductSDSTable :trigger-tab="triggerTab" :trigger-search="triggerProductID" />
                            </b-tab>
                            <b-tab @click="onTabClick('productRecommendation')">
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="far fa-envelope"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ $t('module.recommendation') }}</span>
                                </template>
                                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                                    v-if="isLoading == true">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                                <ProductRecommendationTable :trigger-tab="triggerTab"
                                    :trigger-search="triggerProductID" />
                            </b-tab>
                        </b-tabs>
                    </div>

                    <div style="text-align: center;" v-else>
                        {{ $t('message.noPermissionMessage') }}
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>